import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { HelperService } from '../../../../../services';
import { MeasurementService } from '../../../../../services/measurement.service';

@Component({
    selector: 'app-bolt-hole-diameter',
    templateUrl: './bolt-hole-diameter.component.html',
    styleUrls: ['./bolt-hole-diameter.component.scss'],
})
export class BoltHoleDiameterComponent implements OnInit {
    @Input() form: UntypedFormGroup;

    constructor(private measSvc: MeasurementService) {}

    ngOnInit(): void {
        this.form.markAllAsTouched();
        this.form
            .get('boltHoleDiameter')
            .valueChanges.subscribe((value) => this.form.get('boltHoleDiameter').patchValue(this.measSvc.format(value, UnitType.DefaultLengthUnit)));
    }
}
